<template>
    <Iframe
        v-if="product.FlightTermsUrl"
        :src="product.FlightTermsUrl"
        :border="true"
        :modal="true" />
</template>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { FlightProduct } from '@/api/Cart/cart.interfaces';
    import Iframe from '@ui/components/Iframe/Iframe.vue';

    export default defineComponent({
        name: 'FlightModalTerms',
        components: {
            Iframe,
        },
        props: {
            product: {
                type: Object as PropType<FlightProduct>,
                required: true,
            },
        },
    });
</script>
